import React from 'react';
import { AppConfig } from '@aperza/util';
import CatalogCategoryButton from './CatalogCategoryButton';
import { useAperzaUserContext } from './AperzaUserContext';
export default function ServiceMenu() {
    const { serviceType } = useAperzaUserContext();
    if (serviceType === AppConfig.APERZA_CATALOG) {
        return React.createElement(CatalogCategoryButton, null);
    }
    return React.createElement(React.Fragment, null);
}
